import styled from 'styled-components'
import { theme } from 'styles/theme/hav-theme'

export const Form = styled.form`
  width: 100%;
`

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1.5fr 1fr 1.5fr auto auto;
  gap: ${theme.spacing.sm};
  align-items: end;
  width: 100%;
`

export const FieldWrapper = styled.div`
  width: 100%;
  position: relative;
  min-width: 0;
  
  .MuiFormHelperText-root {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translateY(100%);
    margin-left: 0px;
  }

  
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: flex-end;
`
